<script setup>
import {defineProps, reactive,} from "vue";
// import WhyUsBloc from "@/components/WhyUsBloc.vue";
const props = defineProps({
  locationInfos: {}
})
const locationSectionInfos = reactive(props.locationInfos?.contactSection??[]);
console.log("location section infos");
console.log(locationSectionInfos);
</script>

<template>
  <!-- CONTACT SECTION -->
  <div class="impx-contact">
    <div id="impx-gmap"></div>

    <div class="impx-overlay aqua-darkest  uk-padding uk-padding-remove-bottom uk-padding-remove-horizontal bg-color-csa pattern-1 ">
      <div class="uk-container" >

        <div class="uk-width-2-3@xl uk-width-2-3@l uk-width-2-3@m uk-width-1-1@s uk-margin-medium-bottom">
          <!-- Location -->
          <h4 class="impx-text-white">{{props.locationInfos?.title??''}}</h4>
          <p class="impx-text-large impx-text-light">{{props.locationInfos?.subtitle??''}}</p>
          <!-- Location End -->
        </div>

        <div data-uk-grid class="uk-padding-remove-bottom">
          <!-- Address -->
<!--          <div class="uk-light uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s">-->
<!--            <h5 class="uk-heading-line uk-margin-remove-bottom impx-text-white"><span>Adresse</span></h5>-->
<!--            <p class="impx-text-large uk-margin-top impx-text-light">Yamoussoukro BP 1227 Yakro quartier N'Zuessi<br/> Yamoussoukro, Côte d'Ivoire, BP 1227 YAKRO</p>-->
<!--          </div>-->
          <!-- Address End-->

          <div class="uk-light uk-width-1-4@xl uk-width-1-4@l uk-width-1-4@m uk-width-1-1@s"
               v-for="(location, index) in locationSectionInfos"
               :key="index"
          ><!-- Phone -->
            <h5 class="uk-heading-line uk-margin-bottom impx-text-white"><span>{{location?.title??''}}</span></h5>
            <p class="impx-text-large uk-margin-remove impx-text-light">
              <span
                  v-for="(locationItem, index) in location.contactItems"
                  :key="index"
              >
                {{locationItem?.value??''}}<br/>
              </span>
<!--              +225 07 07 64 59 99<br/>+255 07 00 54 87 90-->
            </p>
          </div>
          <!-- Phone End -->
<!--          <div class="uk-light uk-width-1-4@xl uk-width-1-4@l uk-width-1-4@m uk-width-1-1@s">&lt;!&ndash; Email &ndash;&gt;-->
<!--            <h5 class="uk-heading-line uk-margin-bottom  impx-text-white"><span>Email</span></h5>-->
<!--            <a href="mailt:csainteaugustine@gmail.com" class="impx-text-large impx-text-light">csainteaugustine@gmail.com</a><br/>-->
<!--            <a href="mailt:citesainteaugustine-ci.com" class="impx-text-large impx-text-light">citesainteaugustine-ci.com</a>-->
<!--          </div>-->
          <!-- Email End -->
        </div>

      </div>
    </div>
  </div>
  <!-- CONTACT SECTION END -->
</template>

<style scoped>

</style>